<template>
  <div class="content">
    <!-- 面包屑 -->
    <!-- <div class="breadcrumb">
      <i class="iconfont icondqwz"></i>
      <ul>
        <li class="active">设备管理</li>
      </ul>
    </div> -->
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="jsgl">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 设备厂家管理
        </span>
        <div class="w_normalNav" :parent="self">
          <button class="BlueSmBtn" @click="subSeefrom">搜索</button>
          <button class="OrangeSmBtn" @click="reset">重置</button>
          <button class="GreenSmBtn" @click="addnew">新增</button>
        </div>
        <div class="searchForm1">
          <el-form ref="seefrom" class="uLabelDcontent" :model="seefrom">
            <el-form-item label="厂家名称">
              <el-input placeholder="请输入厂家名称" v-model="seefrom.name"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="tableWrapper" v-loading="!showTable">
          <!-- 后端分页 -->
          <easyTable
            apiUrl="operation/dictionaryType/queryList"
            :parent="self"
            :config="config"
            :other="other"
            ref="deviceManufacturer"
          >
            <template slot="last">
              <el-table-column label="操作" width="300">
                <template slot-scope="scope">
                  <el-link
                    icon="iconfont iconedit"
                    type="text"
                    size="small"
                    @click="edit(scope.$index, scope.row)"
                  >编辑</el-link>
                  <el-link icon="iconfont icondelete" type="text" size="small" @click="deleteMsg(scope.$index,scope.row)">删除</el-link>
                </template>
              </el-table-column>
            </template>
          </easyTable>
        </div>
        <!-- <el-dialog class="editDialog" title="修改用户信息" :visible.sync="editDialogVisible">
          <searchForm :items="items"></searchForm>
          <div slot="footer" class="dialog-footer">
            <el-button class="cancelButton" @click="editDialogVisible = false">取消</el-button>
            <el-button class="confirmButton" type="primary" @click="editDialogVisible = false">确定</el-button>
          </div>
        </el-dialog>-->
        <el-dialog
          class="editDialog"
          :visible.sync="commandDialog"
          :title="title"
          :close-on-click-modal="false"
        >
          <el-form class="adddevice" ref="base" :model="base" :rules="rules">
            <el-form-item prop="name" label="厂家名称">
              <el-input placeholder="请输入厂家名称" v-model.trim="base.name"></el-input>
            </el-form-item>
            <el-form-item prop="remark" label="备注">
              <el-input placeholder="请输入厂家描述" v-model.trim="base.remark"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer" v-if="seeBtn">
            <el-button class="cancelButton" @click="commandDialog = false">取 消</el-button>
            <el-button class="confirmButton" type="primary" @click="submitAdd">确 定</el-button>
          </div>
        </el-dialog>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { dt, obj2urlsp } from "utils";

export default {
  data() {
    return {
      rules: {
        name: [{required: true, message: "请输入厂家名称", trigger: 'blur'}]
      },
      key: "",
      title: "",
      tabName: "jsgl",
      showTable: true,
      other: {
        key: "FACTORY"
      },
      seeBtn: true,
      commandDialog: false,
      seefrom: {
        name: ""
      },
      base: {
        name: "",
        remark: ""
      },
    };
  },
  computed: {
    self() {
      return this;
    },
    config() {
      return [
        {
          prop: "name",
          label: "设备厂家名称"
        },
        {
          prop: "remark",
          label: "备注"
        }
        // {
        //   prop: (row, column) => row.oildrum.rfid_number + row.oildrum.imei,
        //   label: "随便"
        // }
      ];
    },
    dt() {
      return dt.map(({ label }) => label);
    }
  },
  components: {
    normalNav: () => import("public/normalNav"),
    searchForm: () => import("public/searchForm"),
    easyTable: () => import("public/easyTable")
  },
  methods: {
      //搜索
    subSeefrom() {
      this.other = this.seefrom;
      this.other.key = "FACTORY";
      this.$refs.deviceManufacturer.pageToOne();
      this.$nextTick(this.$refs.deviceManufacturer.getData);
    },
    //重置
    reset() {
      this.seefrom.name = ""
    },
    //新增
    addnew() {
      this.seeBtn = true;
      this.title = "新增设备厂家";
      if (this.$refs['base']) this.$refs['base'].clearValidate();
      this.commandDialog = true;
      this.state = 1;
      this.base = {
        name: "",
        remark: ""
      };
    },
    //编辑
    edit(index, row) {
      this.title = "修改设备厂家";
      this.seeBtn = true;
      if (this.$refs['base']) this.$refs['base'].clearValidate();
      this.commandDialog = true;
      this.state = 2;
      this.id = row.id;
      this.base.name = row.name;
      this.base.remark = row.remark;
    },
    //确认
    submitAdd() {
      this.$refs.base.validate(valid => {
        if (valid) {
          if (this.state === 1) {
            this.$axios
              .post(process.env.API_HOST + "operation/dictionaryType/factoryNew", {
                name: this.base.name,
                remark: this.base.remark
              })
              .then(res => {
                //console.log(res);
                if (res.data.status === "10000") {
                  this.commandDialog = false;
                  this.subSeefrom();
                  // let loading = Loading.service({});
                  // loading.close();
                }
              });
          } else if (this.state === 2) {
            this.$axios
              .post(process.env.API_HOST + "operation/dictionaryType/updateById", {
                id: this.id,
                name: this.base.name,
                remark: this.base.remark
              })
              .then(res => {
                //console.log(res);
                if (res.data.status === "10000") {
                  this.commandDialog = false;
                  this.subSeefrom();
                  this.$message({
                    type: "success",
                    message: "修改成功!"
                  });
                  // let loading = Loading.service({});
                  // loading.close();
                }
              });
          }
        }
      });
    },
    //删除
    deleteMsg(index, row) {
      this.$confirm("删除该条数据?", "删除操作", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$axios
          .delete(process.env.API_HOST + "operation/dictionaryType/deleteById", {
            params: {
              id: row.id
            }
          })
          .then(res => {
            if (res.data.status === "10000") {
              this.subSeefrom();
              this.$message({
                type: "success",
                message: "删除成功!"
              });
            }else if(res.data.status === 555) {
              this.$message({
                type: "warning",
                message: "删除失败，该厂家有关联设备!"
              });
            }
          });
      }).catch(()=>{

      })
    },
  }
};
</script>

<style lang="less">
.w_normalNav {
    padding-top: 10px;
    height: 52px;
    position: absolute;
    top: -52px;
    right: 32px;
    // z-index: 99;
  }
.el-input__inner:focus {
  border: 1px solid #3587c7;
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute2/systemConfiguration/first/device/deviceManufacturer.vue